<script>
import { Message } from "element-ui";
import { getDataByField } from "@/utils/UtilsIf";

export default {
  name: "customTable",
  emits: ["selection-change", "getData", "loadedData"],
  props: {
    api: {
      type: Function,
      default: () => Promise.resolve([])
    },
    showPagination: {
      type: Boolean,
      default: () => true
    },
    params: {
      type: Object,
      default: () => {}
    },
    pageConfig: {
      type: Object,
      default: () => ({})
    },
    isMounted: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    params: {
      deep: true,
      handler(newVal, oldVal) {}
    }
  },
  data() {
    return {
      multipleSelection: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 0, // 数据总条数
      data: []
    };
  },
  created() {
    this.isMounted && this.loadData();
  },
  methods: {
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("selection-change", this.multipleSelection);
    },
    search() {
      this.page = 1;
      this.loadData();
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.loadData();
    },
    async loadData() {
      try {
        const {
          pageNum: pageNumField = "pageNum",
          pageSize: pageSizeField = "pageSize",
          list: listField = "rows",
          totalCount: totalCountField = "total",
          pageCount: pageCountField = "pageCount"
        } = this.pageConfig;
        const requestParams = {
          ...this.params
        };
        if (this.showPagination) {
          Object.assign(requestParams, {
            [pageNumField]: this.page,
            [pageSizeField]: this.pageSize
          });
        }
        if (!this.api) return Message.error("请传入api");
        const res = await this.api(requestParams);
        const response = res.data;
        this.$emit("getData", res);
        if (Array.isArray(response)) {
          this.data = response;
          this.total = response.length;
        } else {
          const list = getDataByField(response, listField);
          const totalCount = getDataByField(response, totalCountField);
          const pageCount = getDataByField(response, pageCountField);
          this.data = list || [];
          this.total = Number(totalCount) || 0;
        }
      } catch (error) {
        console.error("加载数据失败:", error);
        this.data = [];
        this.total = 0;
      } finally {
        this.$emit("loadedData");
      }
    }
  }
};
</script>

<template>
  <div class="customTable">
    <el-table
      :data="data"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <slot name="columns"></slot>
    </el-table>
    <!-- 分页器 -->
    <slot name="pagination">
      <el-pagination
        v-if="showPagination"
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </slot>
  </div>
</template>

<style scoped lang="scss"></style>
